module.exports = __webpack_public_path__ + "media/images/new_home/photos-143499fc32e276f4ddf207290f92d8d4.png";